export const steps = {
    PERSONAL_INFO: 'personal-information',
    CONTRACT_DETAILS: 'contract-details',
    COMMUNICATION_CONTRACT: 'communication-and-contract',
    SUMMARY: 'summary-and-consent',
} as const;

export const guardianValue = {
    YES: 'Yes',
    NO: 'No',
} as const;

export const toggleValues = {
    YES: 'Yes',
    NO: 'No',
} as const;

export const verificationStatus = {
    NOT_VERIFIED: 'Not verified',
    VERIFYING: 'Verifying',
    VERIFIED: 'Verified',
} as const;

export const signEnum = {
    SIGNED: 'signed',
    DIGITAL_SIGN: 'digital',
    DIRECT_SIGN: 'paper',
} as const;

export const SignatureType = {
    digital: signEnum.DIGITAL_SIGN,
    paper: signEnum.DIRECT_SIGN,
    unknown: signEnum.DIGITAL_SIGN,
} as const;

/** Communication Toggles Enum */
export const togglesEnum = {
    EMAIL_TOGGLE: 'emailToggle',
    SMS_TOGGLE: 'smsToggle',
    OTHER_TOGGLE: 'otherToggle',
} as const;

export const signTypes = {
    IMAGE: 'image',
    TEXT: 'text',
} as const;

export const INITIAL_STATE_GUARDIAN = {
    guardian: '',
    guardianFirstName: '',
    guardianLastName: '',
    guardianStreet: '',
    guardianHouseNumber: '',
    guardianZipCode: '',
    guardianCity: '',
};

export const INITIAL_STATE_GUARDIAN_ERROR = {
    guardianFirstNameError: '',
    guardianLastNameError: '',
    guardianStreetError: '',
    guardianHouseNumberError: '',
    guardianZipCodeError: '',
    guardianCityError: '',
};

export const INITIAL_STATE_ERROR = {
    titleError: '',
    firstNameError: '',
    middleNameError: '',
    lastNameError: '',
    dobError: '',
    insuranceTypeError: '',
    insuranceNameError: '',
    phoneNoError: '',
    emailError: '',
    streetError: '',
    houseNumberError: '',
    zipCodeError: '',
    cityError: '',
    countryError: '',
    commentError: '',
    genderError: '',
};

export const INITIAL_STATE_ALL_FORMS = [{ name: 'Welcome', route: '/all-forms-welcome', active: true, welcome: true }];

export const INITIAL_STATE_COMMUNICATION = {
    email: '',
    sms: '',
    other: '',
};

export const INITIAL_STATE_COMMUNICATION_TOGGLES = {
    emailToggle: true,
    smsToggle: false,
    otherToggle: false,
};

export const FormTypes = {
    CONSENT_BASE: 'treatment-contract-short',
    CONSENT_LG: 'treatment-contract-extended',
    CONSENT_PRIVACY: 'privacy-herakles',
    CONSENT_ADMISSION: 'admission-herakles',
    CONSENT_COMMUNICATION: 'communication-channels-herakles',
    CONSENT_BACK_COURSE: 'course-enrollment-herakles',
    ANAMNESIS: 'anamnesis',
    CUSTOM: 'custom',
} as const;

export type FormType = (typeof FormTypes)[keyof typeof FormTypes];

export const ALL_FORMS_ROUTES = {
    [FormTypes.ANAMNESIS]: '/anamnesis-health-profile',
    [FormTypes.CONSENT_BASE]: '/consent-treatment',
    [FormTypes.CONSENT_LG]: '/consent-treatment-extended',
};

export const ALL_FORM_PATHS = {
    'admission-herakles': [
        { path: `/consent-admission?step=${steps.PERSONAL_INFO}` },
        { path: `/consent-admission?step=${steps.CONTRACT_DETAILS}` },
        { path: `/consent-admission?step=${steps.SUMMARY}` },
    ],
    'privacy-herakles': [
        { path: `/consent-privacy?step=${steps.PERSONAL_INFO}` },
        { path: `/consent-privacy?step=${steps.CONTRACT_DETAILS}` },
        { path: `/consent-privacy?step=${steps.SUMMARY}` },
    ],
    'communication-channels-herakles': [
        { path: `/consent-communication?step=${steps.PERSONAL_INFO}` },
        { path: `/consent-communication?step=${steps.COMMUNICATION_CONTRACT}` },
        { path: `/consent-communication?step=${steps.SUMMARY}` },
    ],
    'course-enrollment-herakles': [
        { path: `/herakles-course?step=${steps.PERSONAL_INFO}` },
        { path: `/herakles-course?step=${steps.CONTRACT_DETAILS}` },
        { path: `/herakles-course?step=${steps.SUMMARY}` },
    ],
};

export const ALL_FORM_BASE_URLS = {
    ADMISSION: 'consent-admission',
    PRIVACY: 'consent-privacy',
    COMMUNICATION: 'consent-communication',
    COURSE: 'herakles-course',
} as const;

export const UserType = {
    REGISTERED: 'registered',
    UN_REGISTERED: 'unregistered',
} as const;

export const FormDataCategory = {
    SIGNATURE: 'signature',
    LEGAL_GUARDIAN: 'legal-guardian',
} as const;

export const ConsentAllFormsInitialRoutes = {
    MY_APPOINTMENT: '/appointments',
    CONFIRM_APPOINTMENT: '/confirm-appointment',
    ALL_FORMS_CODE: '/all-forms-code',
} as const;

export const FormsEntrySource = {
    RECEPTION_CODE: 'reception-code',
    STATIC_QR: 'static-qr',
    INVITATION: 'invitation',
} as const;

export const FORMS_ENTRY_SOURCE_STORAGE_KEY = 'formsEntrySource';
